// Helpers behind the P5 Booking Direction Leakage card.
//
// The headline figure is the snapshot's own `value_numeric`: the backend computes it and the
// per-class counts from one snapshot, so the card never derives a second figure of its own. The
// counts here only feed the segment bar and the legend.
//
// Input shape: the snapshot's `value_breakdown`, rows of
// { direction_raw, direction_class, mention_count, pct_of_mentions }.

/**
 * Total the breakdown rows per direction class.
 *
 * Rows of any other class are skipped, so a new class cannot inflate the bar's divisor.
 *
 * @param {Array<{direction_class?: string, mention_count?: number, count?: number}>|null|undefined} rows
 * @returns {{direct: number, leakage: number, ambiguous: number}}
 */
export function summarizeLeakageBreakdown(rows) {
  const summary = { direct: 0, leakage: 0, ambiguous: 0 };
  if (!Array.isArray(rows)) return summary;
  for (const r of rows) {
    const cls = r?.direction_class || 'unknown';
    if (cls === 'direct' || cls === 'leakage' || cls === 'ambiguous') {
      summary[cls] += Number(r.mention_count ?? r.count ?? 0);
    }
  }
  return summary;
}
